import {
  Card,
  Flex,
  Text,
} from '@oliasoft-open-source/react-ui-library';
import { FaPlus } from 'react-icons/fa';
import translations from 'client/internationalization/translation-map.json';
import { useTranslation } from 'react-i18next';

const style = {
  border: '0.1rem dashed #808080',
  paddingTop: '20px',
};

export const AddAnalyticsCard = ({ onOpenModal }: { onOpenModal: () => void }) => {
  const { t } = useTranslation();

  return (
    <div style={style}>
      <Card bordered={false}>
        <Flex
          alignItems="center"
          height="200px"
          justifyContent="center"
          direction="column"
        >
          <div>
            <FaPlus size={30} color="gray" onClick={onOpenModal} />
          </div>
          <div>
            <Text faint bold>{t(translations.analytics_addNew)}</Text>
          </div>
        </Flex>
      </Card>
    </div>
  );
};
